import { combineReducers } from 'redux';
import { notificationTypes } from '../actions/_actionTypes';

const byId = (state = {}, action) => {
    switch (action.type) {
        case notificationTypes.FETCH_NOTIFICATIONS:{
            const { payload } = action
            const notificationsById = {};

            for (let i = 0; i < payload.length; i++) {
                const item = payload[i];
                notificationsById[item.id] = item;
            }

            return {
                ...state,
                ...notificationsById
            }
        }
        default:
            return state;
    }
};

const ids = (state = [], action) => {
    switch (action.type) {
        case notificationTypes.FETCH_NOTIFICATIONS: {
            const { payload } = action
            const notificationIds = [];

            for (let i = 0; i < payload.length; i++) {
                const item = payload[i];
                notificationIds.push(item.id);
            }

            return notificationIds;
        }
        default:
            return state;
    }
};

export default combineReducers({
    byId,
    ids,
});


// WEBPACK FOOTER //
// ./src/reducers/notification.reducer.js